import { BrainCog, CalendarHeart, Carrot } from "lucide-react";
import React, { useState } from "react";
import { samplePage, ThemeRegistry } from "../Settings/Utils/ThemeRegistry/ThemeRegistry";
import { resolveAllStyles } from "../Settings/Utils/ThemeResolver";
import { PageRenderer } from "../Settings/Utils/ElementRenderer/Renderer";
import { SelectionProvider } from "../Settings/Utils/ElementRenderer/SelectionContext";
import { HoverProvider } from "../Settings/Utils/ElementRenderer/HoverContext";
import { DragProvider } from "../Settings/Utils/ElementRenderer/DragContext";
import { PickerProvider } from "../Settings/Utils/ElementRenderer/Elements/PickerContext";
import { ResponsiveProvider } from "../Settings/Utils/ElementRenderer/ResponsiveContext";
import { EditorModeProvider } from "../Settings/Utils/ElementRenderer/EditorModeContext";


const modules = [
  {
    tag: "Module 1",
    title: "FUNDAMENTALS",
    lessons: [
      "Introduction",
      "How the Brain Works: Neuroplasticity",
      "How Success Works: Formula",
      "How Success Works: Pareto Principle",
    ],
  },
//   {
//     tag: "Module 2",
//     title: "MINDSET & CLARITY",
//     lessons: [
//       "Identifying Limiting Beliefs",
//       "Building an Attack Mindset",
//       "Decision Making Frameworks",
//       "Designing Your Ideal Life",
//     ],
//   },
//   {
//     tag: "Module 3",
//     title: "SYSTEMS & HABITS",
//     lessons: [
//       "Daily Systems vs Motivation",
//       "Habit Stacking & Triggers",
//       "Tracking Progress the Right Way",
//       "Avoiding Burnout Over Time",
//     ],
//   },
//   {
//     tag: "Module 4",
//     title: "EXECUTION PLAYBOOK",
//     lessons: [
//       "Planning 90-Day Sprints",
//       "Weekly Battle Plans",
//       "How to Handle Resistance",
//       "Review, Reflect & Reset",
//     ],
//   },
//   {
//     tag: "Module 5",
//     title: "BONUS & IMPLEMENTATION",
//     lessons: [
//       "Q&A and Case-Studies",
//       "Real Life Implementation Examples",
//       "Long-Term Strategy",
//       "Next Steps After the Bootcamp",
//     ],
//   },
];

const CurriculumCard1 = () => {
//     const resolved = resolveAllStyles(samplePage, ThemeRegistry?.theme1);
// console.log(JSON.stringify(resolved, null, 2));
const [page , setPage]= useState(resolveAllStyles(samplePage, ThemeRegistry.theme1));

  return (<>
    <section className="cc-section">
      <div className="cc-inner">

        {/* LEFT – Instructor image */}
        <div className="cc-left">
          <div className="cc-photo-wrap">
            <img
              src="https://i.postimg.cc/NjF4BFVz/red_haired_lady_eyeglasses_holds_books_shows_ok_sign_1_removebg_preview.png"
              alt="Instructor"
            />
          </div>
        </div>

        {/* RIGHT – Curriculum */}
        <div className="cc-right">
          <h2 className="cc-title">Course Curriculum</h2>

          {/* Info bar */}
          <div className="cc-info-bar">
            <span>5 Modules</span>
            <span>16+ hours of live learning experience</span>
          </div>

          {/* Module cards */}
          <div className="cc-modules">
            {modules.map((mod, idx) => (
              <div className="cc-module-card" key={idx}>
                <div className="cc-module-header">
                  <span className="pentagon-label">{mod.tag}</span>
                </div>

                <div className="cc-module-body">
                  <div className="cc-module-left">
                    <h3>{mod.title}</h3>
                    <ul className="cc-timeline">
                      {mod.lessons.map((lesson, i) => (
                        <li key={i}>
                          <span className="cc-dot" />
                          <span className="cc-line" />
                          <p>{lesson}</p>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Icon on right */}
                  <div className="cc-module-icon">
                    <div className="cc-icon-glow">
                      <span className="cc-icon-atom">⚛</span>
                      <span className="cc-icon-doc"><Carrot strokeWidth={0.5} size={36} /></span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    
{/* <PageRenderer page={page} setPage={(v)=>{setPage(v)}} /> */}
    </section>
    <SelectionProvider>
  <HoverProvider>
     <DragProvider>
        <PickerProvider>
          <ResponsiveProvider>
            <EditorModeProvider>
    <PageRenderer page={page} setPage={setPage} />
    </EditorModeProvider>
    </ResponsiveProvider>
    </PickerProvider>
    </DragProvider>
  </HoverProvider>
</SelectionProvider>
    <style>{`.cc-section {
  background: rgba(144, 202, 249,0.051);
  padding: 0px 0;
  display: flex;
  justify-content: center;
  color: #222222;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}
.pentagon-label {
  position: relative;
  background: rgba(144, 202, 249,0.51);
  color: #222222;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 4px 4px 0 0;
  display: inline-block;
  clip-path: polygon(
    0% 0%,
    100% 0%,
    100% 100%,
    20% 100%,
    0% 30%
  );
}
.cc-inner {
  width: 100%;
  max-width: 1300px;
  display: flex;
  gap: 36px;
}

/* LEFT SIDE */

.cc-left {
  flex: 0 0 35%;
}

.cc-photo-wrap {
  background: radial-gradient(circle at top, rgba(144, 202, 249,0.41) 0%, rgba(144, 202, 249,0.1) 50%, rgba(144, 202, 249,0.1) 100%);
  border-radius: 26px;padding-top:50px;
  overflow: hidden;
  
}

.cc-photo-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* RIGHT SIDE */

.cc-right { 
  flex: 1;padding-top:50px;
}

.cc-title {
  font-size: 36px;
  font-weight: 800;
  margin-bottom: 16px;
}

.cc-info-bar {
  background: rgba(144, 202, 249,0.1);
  border-radius: 16px;
  padding: 12px 20px;
  display: flex;
  gap: 16px;
  font-size: 14px;
  margin-bottom: 20px;
}

.cc-info-bar span + span {
  border-left: 1px solid rgba(63, 133, 190, 0.51);
  padding-left: 12px;
}

/* MODULE CARDS */

.cc-modules {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cc-module-card {
  background: #ffffff;
  border-radius: 18px;
  padding-bottom: 18px;
//   border: 1px solid rgba(144, 202, 249,0.51);
  box-shadow: 0 0 12px rgba(144, 202, 249,0.1);
}

.cc-module-header {
  padding: 8px 18px 0;
}

.cc-module-tag {
  display: inline-block;
  background: rgba(144, 202, 249,0.51);
  color: #222222;
  padding: 6px 14px;
  border-radius: 18px 18px 0 0;
  font-size: 13px;
}

/* Body layout */

.cc-module-body {
  display: flex;
  padding: 14px 20px 20px;
  gap: 24px;
}

.cc-module-left {
  flex: 1;
}

.cc-module-left h3 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 12px;
}

/* Timeline list */

.cc-timeline {
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
}

.cc-timeline li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 10px;
  position: relative;
}

.cc-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(144, 202, 249,1);
  margin-top: 5px;
  z-index: 2;
}

.cc-line {
  position: absolute;
  left: 4px;
  top: 14px;
  width: 2px;
  height: calc(100% - 0px);
  background: linear-gradient(to bottom, rgba(144, 202, 249,0.51), transparent);
  opacity: 0.7;
}

.cc-timeline li:last-child .cc-line {
  height: 0; /* no line after last */
}

.cc-timeline p {
  font-size: 14px;
  color: #333333;
}

/* Icon glow */

.cc-module-icon {
  flex: 0 0 120px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cc-icon-glow {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(144, 202, 249,0.31) 0%, transparent 60%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: rgba(144, 202, 249,1);
  font-size: 26px;
  position: relative;
}

.cc-icon-atom {
  font-size: 56px;
}

.cc-icon-doc {
  font-size: 20px;
  position: absolute;
  bottom: 12px;
  right: 18px;
}

/* RESPONSIVE */

@media (max-width: 992px) {
  .cc-inner {
    flex-direction: column; 
  }

.cc-left,.cc-right {
  flex: 1;padding-top:10px;
}
  

  .cc-photo-wrap {
    max-width: 420px;
    margin: 0 auto 20px;
  }
}

@media (max-width: 600px) {
  .cc-module-body {
   
  }
.cc-left,.cc-right {
  flex: 1;padding-top:10px;
}
   .cc-module-icon {
    justify-content: flex-start;
   }

  .cc-info-bar {
    flex-direction: column;
    align-items: flex-start;
  }
}
`}</style>
  </>);
};

export default CurriculumCard1;
